import {Injectable} from '@angular/core';
import {HttpClient} from "../http.client";
import {Pagination} from "../entities/pagination";
import {Sorting} from "../entities/sorting";
import {User} from "../entities/user/user";
import {AdvancedSearch} from '../entities/advanced-search';
import * as FileSaver from 'file-saver';

@Injectable()
export class UserService {
    constructor(private _http: HttpClient) {
    }

    getUsers(currentPage: number, resultsPerPage: number, sorting: Sorting, search="", advancedSearch?: AdvancedSearch, filters?: any) {
        let getStr = "/user/getAll?current_page=" + currentPage +
            "&results_per_page=" + resultsPerPage +
            "&sorting[by]=" + sorting.by +
            "&sorting[direction]=" + sorting.direction +
            "&search=" + search;
        if (!search) {
            getStr = getStr +
                "&advanced_search[reg_date]=" + (advancedSearch.reg_date ? advancedSearch.reg_date.formatted : '') +
                "&advanced_search[name]=" + advancedSearch.name +
                "&advanced_search[email]=" + advancedSearch.email +
                "&advanced_search[company]=" + advancedSearch.company +
                "&advanced_search[group_id]=" + (advancedSearch.group_id ? advancedSearch.group_id : '')  +
                "&advanced_search[markup]=" + (advancedSearch.markup || '') +
                (advancedSearch.country.length? "&advanced_search[country][]=" + advancedSearch.country.map(function(k, i){
                    return k.id;
                }).join('&advanced_search[country][]=') : '') +
                "&advanced_search[manager]=" + advancedSearch.manager;
        }
        let data = {};
        if (filters) {
            // for (const k in filters) {
            //     if (filters[k].length) {
            //         getStr = getStr +
            //             "&filter[" + k + "][]=" + filters[k].join("&filter[" + k + "][]=");
            //     }
            // }
            data = {
                filter: filters
            };
        }

        return this._http.post(getStr, data);
    }

    getById(userId: number) {
        return this._http.get(
            "/user/getById?id=" + userId
        );
    }

    getPocList() {
        return this._http.get("/user/getPocList");
    }

    createUser(user: User) {
        return this._http.post("/authentication/signUp", {
            'email': user.email,
            'first_name': user.first_name,
            'last_name': user.last_name,
            'country': user.country,
            'company': user.company,
            'business_type': user.business_type,
            'phone_prefix': user.phone_prefix,
            'phone_suffix': user.phone_suffix,
            'password': user.password
        })
    }


    editUser(user: any) {
        let id = ((user.permissions.group_id == '0' || user.permissions.group_id == '4' || user.permissions.group_id == '5') ? null : (+user.poc.id));
        return this._http.post("/user/update", {
            id: +user.id,
            poc_id: id,
            group_id: +user.permissions.group_id,
            default_markup: user.default_markup
        })
    }

    blockUser(userId: number) {
        return this._http.post("/user/block", {
            id: userId
        })
    }

    unblockUser(userId: number) {
        return this._http.post("/user/unblock", {
            id: userId
        })
    }

    deleteUser(userId: number) {
        return this._http.post("/user/delete", {
            id: userId
        })
    }

    bulkDeleteUsers(ids: number[]) {
        return this._http.post("/user/bulkDelete", {
            ids: ids
        });
    }

    bulkBlockUsers(ids: number[]) {
        return this._http.post("/user/bulkBlock", {
            ids: ids
        });
    }

    exportExcel(ids: number[]) {
        return this._http.post("/user/exportExcel", {
            ids: ids
        }, true).subscribe((res) => {
            const blob = new Blob([res._body], {
                type: "application/vnd.ms-excel"
            });
            FileSaver.saveAs(blob, "export.xlsx");
        });
    }

    bulkUnblockUsers(ids: number[]) {
        return this._http.post("/user/bulkUnblock", {
            ids: ids
        });
    }

    bulkEditUsers(ids: number[], user: User) {
        return this._http.post("/user/bulkEdit", {
            ids: ids,
            user: {
                poc_id: user.poc.id,
                group_id: +user.permissions.group_id,
                default_markup: +user.default_markup
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/users/user.service.ts